import { useEffect, useState } from "react";

// Full-screen spinner that, after a few seconds, explains the delay: the
// backend scales to zero when idle, so the first request after a quiet
// period can take ~15-20s while the server and database wake up.
function LoadingScreen({ title, delayMs = 4000 }) {
  const [showSlowHint, setShowSlowHint] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowSlowHint(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return (
    <div className="loading-page">
      <div className="spinner" />
      <h2>{title}</h2>
      <p className={`loading-slow-hint${showSlowHint ? " visible" : ""}`}>
        Still working — after some idle time our servers take a moment to wake
        up. This can take up to 20 seconds. Thanks for your patience!
      </p>
    </div>
  );
}

export default LoadingScreen;
